import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { SystemContext } from "../../context/SystemContext";
import { SystemItem } from "../SystemItem";
import { EditSystemFormInputs } from "./EditSystemFormInputs";
import { useEditSystemForm } from "./useEditSystemForm";

export interface EditSystemFormProps {
    onCancel(): void;
    onSubmit(): void;
    itemToEditId: string;
}

export const EditSystemForm: React.FC<EditSystemFormProps> = (props: EditSystemFormProps) => {
    const { editSystem } = useEditSystemForm(props.itemToEditId);

    const { systemItems } = useContext(SystemContext);
    const { itemToEditId } = props;

    const { errors, control, formState, reset, handleSubmit } = useForm<EditSystemFormInputs>({
        defaultValues: getDefaultValues(systemItems, itemToEditId),
        criteriaMode: "all"
    });

    const handleEditSystem = async (inputs: EditSystemFormInputs) => {
        await editSystem(inputs);
        props.onSubmit();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditSystem)}>
            <FormFields>
                <Stack>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{ required: "Enter name" }}
                    />
                    <FormTextField
                        label="Description"
                        control={control}
                        rules={{ required: "Enter description" }}
                        name="description"
                        errors={errors}
                        multiline={true}
                    />
                </Stack>
            </FormFields>
            <FormActions
                isLoading={formState.isSubmitting || formState.isValidating}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};

const getDefaultValues = (systems: SystemItem[], itemToEditId: string): EditSystemFormInputs => {
    const itemToEdit = systems.find((system: SystemItem) => system.id === itemToEditId);

    if (!itemToEdit) {
        throw new Error(`Could not find system ${itemToEditId} to edit.`);
    }

    return {
        name: itemToEdit.name,
        description: itemToEdit.description
    };
};
